import React from "react";
import PropTypes from "prop-types";
import Markdown from "react-markdown";
import { Flex, Box, Text } from "rebass";
import { Container } from "@components/atoms";

const renderers = {
  link: ({ href, children }) => (
    <Text
      as="a"
      children={children}
      color="primary"
      href={href}
      variant="body"
      sx={{
        "*": {
          color: "primary",
        },
        "&:visited": {
          color: "primary",
        },
        wordBreak: "break-all",
        textDecoration: "underline",
      }}
    />
  ),
  list: ({ children }) => <Box as="ul" pl="2rem" children={children} />,
  listItem: ({ children }) => (
    <Text
      variant="body"
      color="dark80"
      as="li"
      children={children}
      sx={{
        listStyle: "disc",
      }}
    />
  ),
  text: ({ value }) => <Text variant="body" color="dark80" as="p" children={value} />,
};

export const SectionBlock = ({ title, content }) => {
  return (
    <Container>
      <Flex flexDirection={["column", "column", "row"]} mx="-1.5rem">
        <Box px="1.5rem" width={["100%", null, "30%"]} flexShrink="0" mb={["2rem", null, 0]}>
          <Text as="h2" variant="subHeader" fontSize={["xl", "null", "3xl"]}>
            {title}
          </Text>
        </Box>

        <Box px="1.5rem">
          <Text>
            <Markdown source={content} escapeHtml={false} renderers={renderers} />
          </Text>
        </Box>
      </Flex>
    </Container>
  );
};

SectionBlock.propTypes = {
  content: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};
